// product countdown
function countDownIni(countdown) {
  $(countdown).each(function () {
    var countdown = $(this);
    var promoperiod;
    if (countdown.attr("data-promoperiod")) {
      promoperiod =
        new Date().getTime() + parseInt(countdown.attr("data-promoperiod"), 10);
    } else if (countdown.attr("data-countdown")) {
      promoperiod = countdown.attr("data-countdown");
    }
    if (Date.parse(promoperiod) - Date.parse(new Date()) > 0) {
      $(this).addClass("countdown-block");
      $(this).countdown(promoperiod, function (event) {
        // countdown.html(event.strftime('%-w weeks %-d days %Hh %Mm %Ss'));
        countdown.html(
          event.strftime(
            '<span class="countdown"><span class="time">%D</span><span class="time-txt">Days</span></span>' +
              '<span class="countdown"><span class="time">%H</span><span class="time-txt">Hour</span></span>' +
              '<span class="countdown"><span class="time">%M</span><span class="time-txt">Min</span></span>' +
              '<span class="countdown"><span class="time">%S</span><span class="time-txt">Sec</span></span>'
          )
        );
      });
    }
  });
}
countDownIni(".flip-countdown,.js-flip-countdown");


// custom countdown
function offerclockIni(countdown) {
  $(countdown).each(function () {
    var countdown = $(this);
    var promoperiod;
    if (countdown.attr("data-promoperiod")) {
      promoperiod =
        new Date().getTime() + parseInt(countdown.attr("data-promoperiod"), 10);
    } else if (countdown.attr("data-countdown")) {
      promoperiod = countdown.attr("data-countdown");
    }
    if (Date.parse(promoperiod) - Date.parse(new Date()) > 0) {
      $(this).addClass("offerclock-block");
      $(this).countdown(promoperiod, function (event) {
        // countdown.html(event.strftime('%-w weeks %-d days %Hh %Mm %Ss'));
        countdown.html(
          event.strftime(
            '<span class="time"><span class="count">%D</span><span class="offertext">Days</span></span>' +
              '<span class="time"><span class="count">%H</span><span class="offertext">Hour</span></span>' +
              '<span class="time"><span class="count">%M</span><span class="offertext">Min</span></span>' +
              '<span class="time"><span class="count">%S</span><span class="offertext">Sec</span></span>'
          )
        );
      });
    }
  });
}
offerclockIni(".offerclock,.js-offerclock");

/* Scroll Horizontally */
function horizontalScroll() {
  const stickyContainer = document.querySelectorAll(".stickyscroll");
  var scrollingHorizontally = [];
  stickyContainer.forEach(function (postScroll, index) {
    scrollingHorizontally[index] = true;
    if (postScroll) {
      postScroll.addEventListener("wheel", (event) => {
        if (scrollingHorizontally[index]) {
          postScroll.scrollBy({
            left: event.deltaY < 0 ? -200 : 200,
          });
          event.preventDefault();

          // check if the user has reached the end of the slider
          if (
            postScroll.scrollLeft >=
            postScroll.scrollWidth - postScroll.clientWidth
          ) {
            scrollingHorizontally[index] = false;
            postScroll.style.overflowY = "auto";
          }
        } else {
          scrollingHorizontally[index] = true;
          // (scroll the page up/down)
          return true;
        }
      });
    }
  });
}
$(document).ready(function () {
  horizontalScroll();
});
$(window).resize(function () {
  horizontalScroll();
});

// grid-list

$(document).ready(function () {
  $(".btn-group").each(function () {
    var active,
      content,
      links = $(this).find("a");
    active = links.first().addClass("active");
    content = $(active.attr("href"));
    links.not(":first").each(function () {
      $($(this).attr("href")).hide();
    });
    $(this)
      .find("a")
      .click(function (e) {
        active.removeClass("active");
        content.hide();
        active = $(this);
        content = $($(this).attr("href"));
        active.addClass("active");
        content.show();
        return false;
      });
  });
});
$(document).ready(function () {
  $("#col_1").click(function (event) {
    event.preventDefault();
    $("#product-grid .grid__item").removeClass("");
    $("#product-grid .grid__item").addClass("list-group-item");
  });
  $("#col_2").click(function (event) {
    event.preventDefault();
    $("#product-grid .grid__item").removeClass("list-group-item");
    $("#product-grid .grid__item").addClass("");
  });
});

$(".ttloader").addClass("hide-loader");

$(window).scroll(function () {
  if ($(this).scrollTop() > 500) {
    $(".top_button").fadeIn(500);
  } else {
    $(".top_button").fadeOut(500);
  }
});

$(".top_button").click(function (event) {
  event.preventDefault();
  $("html, body").animate(
    {
      scrollTop: 0,
    },
    800
  );
});

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute("role", "button");
  summary.setAttribute(
    "aria-expanded",
    summary.parentNode.hasAttribute("open")
  );

  if (summary.nextElementSibling.getAttribute("id")) {
    summary.setAttribute("aria-controls", summary.nextElementSibling.id);
  }

  summary.addEventListener("click", (event) => {
    event.currentTarget.setAttribute(
      "aria-expanded",
      !event.currentTarget.closest("details").hasAttribute("open")
    );
  });

  if (summary.closest("header-drawer")) return;
  summary.parentElement.addEventListener("keyup", onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== "TAB") return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener("focusout", trapFocusHandlers.focusout);
  document.addEventListener("focusin", trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === "INPUT" &&
    ["search", "text", "email", "url"].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    "ARROWUP",
    "ARROWDOWN",
    "ARROWLEFT",
    "ARROWRIGHT",
    "TAB",
    "ENTER",
    "SPACE",
    "ESCAPE",
    "HOME",
    "END",
    "PAGEUP",
    "PAGEDOWN",
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener("keydown", (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener("mousedown", (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    "focus",
    () => {
      if (currentFocusedElement)
        currentFocusedElement.classList.remove("focused");

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add("focused");
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll(".js-youtube").forEach((video) => {
    video.contentWindow.postMessage(
      '{"event":"command","func":"' + "pauseVideo" + '","args":""}',
      "*"
    );
  });
  document.querySelectorAll(".js-vimeo").forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', "*");
  });
  document.querySelectorAll("video").forEach((video) => video.pause());
  document.querySelectorAll("product-model").forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== "ESCAPE") return;

  const openDetailsElement = event.target.closest("details[open]");
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector("summary");
  openDetailsElement.removeAttribute("open");
  summaryElement.setAttribute("aria-expanded", false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector("input");
    this.changeEvent = new Event("change", { bubbles: true });

    this.input.addEventListener("change", this.onInputChange.bind(this));
    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(
      PUB_SUB_EVENTS.quantityUpdate,
      this.validateQtyRules.bind(this)
    );
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === "plus" ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value)
      this.input.dispatchEvent(this.changeEvent);
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const min = parseInt(this.input.min);
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle("disabled", value <= min);
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle("disabled", value >= max);
    }
  }
}

customElements.define("quantity-input", QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`,
    },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == "undefined") {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent("on" + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options["method"] || "post";
  var params = options["parameters"] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (
  country_domid,
  province_domid,
  options
) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(
    options["hideElement"] || province_domid
  );

  Shopify.addListener(
    this.countryEl,
    "change",
    Shopify.bind(this.countryHandler, this)
  );

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute("data-default");
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute("data-provinces");
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = "none";
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement("option");
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement("option");
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector("details");

    this.addEventListener("keyup", this.onKeyUp.bind(this));
    this.addEventListener("focusout", this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll("summary").forEach((summary) =>
      summary.addEventListener("click", this.onSummaryClick.bind(this))
    );
    this.querySelectorAll("button:not(.localization-selector)").forEach(
      (button) =>
        button.addEventListener("click", this.onCloseButtonClick.bind(this))
    );
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== "ESCAPE") return;

    const openDetailsElement = event.target.closest("details[open]");
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(
          event,
          this.mainDetailsToggle.querySelector("summary")
        )
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest(".has-submenu");
    const isOpen = detailsElement.hasAttribute("open");
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(
        summaryElement.nextElementSibling,
        detailsElement.querySelector("button")
      );
      summaryElement.nextElementSibling.removeEventListener(
        "transitionend",
        addTrapFocus
      );
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen
        ? this.closeMenuDrawer(event, summaryElement)
        : this.openMenuDrawer(summaryElement);

      if (window.matchMedia("(max-width: 990px)")) {
        document.documentElement.style.setProperty(
          "--viewport-height",
          `${window.innerHeight}px`
        );
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add("menu-opening");
        summaryElement.setAttribute("aria-expanded", true);
        parentMenuElement && parentMenuElement.classList.add("submenu-open");
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener(
              "transitionend",
              addTrapFocus
            );
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });
    summaryElement.setAttribute("aria-expanded", true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove("menu-opening");
    this.mainDetailsToggle.querySelectorAll("details").forEach((details) => {
      details.removeAttribute("open");
      details.classList.remove("menu-opening");
    });
    this.mainDetailsToggle
      .querySelectorAll(".submenu-open")
      .forEach((submenu) => {
        submenu.classList.remove("submenu-open");
      });
    document.body.classList.remove(
      `overflow-hidden-${this.dataset.breakpoint}`
    );
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);
  }

  onFocusOut() {
    setTimeout(() => {
      if (
        this.mainDetailsToggle.hasAttribute("open") &&
        !this.mainDetailsToggle.contains(document.activeElement)
      )
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest("details");
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest(".submenu-open");
    parentMenuElement && parentMenuElement.classList.remove("submenu-open");
    detailsElement.classList.remove("menu-opening");
    detailsElement
      .querySelector("summary")
      .setAttribute("aria-expanded", false);
    removeTrapFocus(detailsElement.querySelector("summary"));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute("open");
        if (detailsElement.closest("details[open]")) {
          trapFocus(
            detailsElement.closest("details[open]"),
            detailsElement.querySelector("summary")
          );
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define("menu-drawer", MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector(".section-header");
    this.borderOffset =
      this.borderOffset ||
      this.closest(".header-wrapper").classList.contains(
        "header-wrapper--border-bottom"
      )
        ? 1
        : 0;
    document.documentElement.style.setProperty(
      "--header-bottom-position",
      `${parseInt(
        this.header.getBoundingClientRect().bottom - this.borderOffset
      )}px`
    );
    this.header.classList.add("menu-open");

    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });

    summaryElement.setAttribute("aria-expanded", true);
    window.addEventListener("resize", this.onResize);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) return;
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove("menu-open");
    window.removeEventListener("resize", this.onResize);
  }

  onResize = () => {
    this.header &&
      document.documentElement.style.setProperty(
        "--header-bottom-position",
        `${parseInt(
          this.header.getBoundingClientRect().bottom - this.borderOffset
        )}px`
      );
    document.documentElement.style.setProperty(
      "--viewport-height",
      `${window.innerHeight}px`
    );
  };
}

customElements.define("header-drawer", HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      "click",
      this.hide.bind(this, false)
    );
    this.addEventListener("keyup", (event) => {
      if (event.code.toUpperCase() === "ESCAPE") this.hide();
    });
    if (this.classList.contains("media-modal")) {
      this.addEventListener("pointerup", (event) => {
        if (
          event.pointerType === "mouse" &&
          !event.target.closest("deferred-media, product-model")
        )
          this.hide();
      });
    } else {
      this.addEventListener("click", (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector(".template-popup");
    document.body.classList.add("overflow-hidden");
    this.setAttribute("open", "");
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove("overflow-hidden");
    document.body.dispatchEvent(new CustomEvent("modalClosed"));
    this.removeAttribute("open");
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define("modal-dialog", ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector("button");

    if (!button) return;
    button.addEventListener("click", () => {
      const modal = document.querySelector(this.getAttribute("data-modal"));
      if (modal) modal.show(button);
    });
  }
}
customElements.define("modal-opener", ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener("click", this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute("loaded")) {
      const content = document.createElement("div");
      content.appendChild(
        this.querySelector("template").content.firstElementChild.cloneNode(true)
      );

      this.setAttribute("loaded", true);
      const deferredElement = this.appendChild(
        content.querySelector("video, model-viewer, iframe")
      );
      if (focus) deferredElement.focus();
      if (
        deferredElement.nodeName == "VIDEO" &&
        deferredElement.getAttribute("autoplay")
      ) {
        // force autoplay for safari
        deferredElement.play();
      }
    }
  }
}

customElements.define("deferred-media", DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector(".slider-counter--current");
    this.pageTotalElement = this.querySelector(".slider-counter--total");
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener("scroll", this.update.bind(this));
    this.prevButton.addEventListener("click", this.onButtonClick.bind(this));
    this.nextButton.addEventListener("click", this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(
      (element) => element.clientWidth > 0
    );
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset =
      this.sliderItemsToShow[1].offsetLeft -
      this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) /
        this.sliderItemOffset
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    // Temporarily prevents unneeded updates resulting from variant changes
    // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
    if (!this.slider || !this.nextButton) return;

    const previousPage = this.currentPage;
    this.currentPage =
      Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent("slideChanged", {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      );
    }

    if (this.enableSliderLooping) return;

    if (
      this.isSlideVisible(this.sliderItemsToShow[0]) &&
      this.slider.scrollLeft === 0
    ) {
      this.prevButton.setAttribute("disabled", "disabled");
    } else {
      this.prevButton.removeAttribute("disabled");
    }

    if (
      this.isSlideVisible(
        this.sliderItemsToShow[this.sliderItemsToShow.length - 1]
      )
    ) {
      this.nextButton.setAttribute("disabled", "disabled");
    } else {
      this.nextButton.removeAttribute("disabled");
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide =
      this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (
      element.offsetLeft + element.clientWidth <= lastVisibleSlide &&
      element.offsetLeft >= this.slider.scrollLeft
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === "next"
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;
    this.slider.scrollTo({
      left: this.slideScrollPosition,
    });
  }
}

customElements.define("slider-component", SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector(".slider-buttons");
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector(".slideshow__slide");
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(
      this.sliderControlWrapper.querySelectorAll(".slider-counter__link")
    );
    this.sliderControlLinksArray.forEach((link) =>
      link.addEventListener("click", this.linkToSlide.bind(this))
    );
    this.slider.addEventListener("scroll", this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.slider.getAttribute("data-autoplay") === "true")
      this.setAutoPlay();
  }

  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector(".slideshow__autoplay");
    this.autoplaySpeed = this.slider.dataset.speed * 1000;

    this.sliderAutoplayButton.addEventListener(
      "click",
      this.autoPlayToggle.bind(this)
    );
    this.addEventListener("mouseover", this.focusInHandling.bind(this));
    this.addEventListener("mouseleave", this.focusOutHandling.bind(this));
    this.addEventListener("focusin", this.focusInHandling.bind(this));
    this.addEventListener("focusout", this.focusOutHandling.bind(this));

    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === "previous") {
      this.slideScrollPosition =
        this.slider.scrollLeft +
        this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === "next") {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition,
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll(".slider-counter__link");
    this.prevButton.removeAttribute("disabled");

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove("slider-counter__link--active");
      link.removeAttribute("aria-current");
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add(
      "slider-counter__link--active"
    );
    this.sliderControlButtons[this.currentPage - 1].setAttribute(
      "aria-current",
      true
    );
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    const focusedOnAutoplayButton =
      event.target === this.sliderAutoplayButton ||
      this.sliderAutoplayButton.contains(event.target);
    if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
    this.play();
  }

  focusInHandling(event) {
    const focusedOnAutoplayButton =
      event.target === this.sliderAutoplayButton ||
      this.sliderAutoplayButton.contains(event.target);
    if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
      this.play();
    } else if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute("aria-live", "off");
    clearInterval(this.autoplay);
    this.autoplay = setInterval(
      this.autoRotateSlides.bind(this),
      this.autoplaySpeed
    );
  }

  pause() {
    this.slider.setAttribute("aria-live", "polite");
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add("slideshow__autoplay--paused");
      this.sliderAutoplayButton.setAttribute(
        "aria-label",
        window.accessibilityStrings.playSlideshow
      );
    } else {
      this.sliderAutoplayButton.classList.remove("slideshow__autoplay--paused");
      this.sliderAutoplayButton.setAttribute(
        "aria-label",
        window.accessibilityStrings.pauseSlideshow
      );
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length
        ? 0
        : this.slider.scrollLeft +
          this.slider.querySelector(".slideshow__slide").clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll("a");
      if (index === this.currentPage - 1) {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.removeAttribute("tabindex");
          });
        item.setAttribute("aria-hidden", "false");
        item.removeAttribute("tabindex");
      } else {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.setAttribute("tabindex", "-1");
          });
        item.setAttribute("aria-hidden", "true");
        item.setAttribute("tabindex", "-1");
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
        (this.sliderControlLinksArray.indexOf(event.currentTarget) +
          1 -
          this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define("slideshow-component", SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("change", this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, "", false);
    this.updatePickupAvailability();
    this.updateSKU();
    this.removeErrorMessage();
    this.updateVariantStatuses();

    if (!this.currentVariant) {
      this.toggleAddButton(true, "", true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  updateOptions() {
    this.options = Array.from(
      this.querySelectorAll("select"),
      (select) => select.value
    );
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGalleries = document.querySelectorAll(
      `[id^="MediaGallery-${this.dataset.section}"]`
    );
    mediaGalleries.forEach((mediaGallery) =>
      mediaGallery.setActiveMedia(
        `${this.dataset.section}-${this.currentVariant.featured_media.id}`,
        true
      )
    );

    const modalContent = document.querySelector(
      `#ProductModal-${this.dataset.section} .product-media-modal__content`
    );
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector(
      `[data-media-id="${this.currentVariant.featured_media.id}"]`
    );
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === "false") return;
    window.history.replaceState(
      {},
      "",
      `${this.dataset.url}?variant=${this.currentVariant.id}`
    );
  }

  updateShareUrl() {
    const shareButton = document.getElementById(
      `Share-${this.dataset.section}`
    );
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(
      `${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`
    );
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(
      (variant) => this.querySelector(":checked").value === variant.option1
    );
    const inputWrappers = [...this.querySelectorAll(".product-form__input")];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [
        ...option.querySelectorAll('input[type="radio"], option'),
      ];
      const previousOptionSelected =
        inputWrappers[index - 1].querySelector(":checked").value;
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter(
          (variant) =>
            variant.available &&
            variant[`option${index}`] === previousOptionSelected
        )
        .map((variantOption) => variantOption[`option${index + 1}`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue);
    });
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute("value"))) {
        input.innerText = input.getAttribute("value");
      } else {
        input.innerText = window.variantStrings.unavailable_with_option.replace(
          "[value]",
          input.getAttribute("value")
        );
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector("pickup-availability");
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute("available");
      pickUpAvailability.innerHTML = "";
    }
  }
  updateSKU() {
    if (this.currentVariant.sku) {
      $(".js-variant-sku").html(this.currentVariant.sku);
    } else {
      $(".js-variant-sku").html("N/A");
    }
  }

  removeErrorMessage() {
    const section = this.closest("section");
    if (!section) return;

    const productForm = section.querySelector("product-form");
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;
    const sectionId = this.dataset.originalSection
      ? this.dataset.originalSection
      : this.dataset.section;

    fetch(
      `${this.dataset.url}?variant=${requestedVariantId}&section_id=${
        this.dataset.originalSection
          ? this.dataset.originalSection
          : this.dataset.section
      }`
    )
      .then((response) => response.text())
      .then((responseText) => {
        // prevent unnecessary ui changes from abandoned selections
        if (this.currentVariant.id !== requestedVariantId) return;

        const html = new DOMParser().parseFromString(responseText, "text/html");
        const destination = document.getElementById(
          `price-${this.dataset.section}`
        );
        const source = html.getElementById(
          `price-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`
        );
        const skuSource = html.getElementById(
          `Sku-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`
        );
        const skuDestination = document.getElementById(
          `Sku-${this.dataset.section}`
        );
        const inventorySource = html.getElementById(
          `Inventory-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`
        );
        const inventoryDestination = document.getElementById(
          `Inventory-${this.dataset.section}`
        );

        if (source && destination) destination.innerHTML = source.innerHTML;
        if (inventorySource && inventoryDestination)
          inventoryDestination.innerHTML = inventorySource.innerHTML;
        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML;
          skuDestination.classList.toggle(
            "visibility-hidden",
            skuSource.classList.contains("visibility-hidden")
          );
        }

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove("visibility-hidden");

        if (inventoryDestination)
          inventoryDestination.classList.toggle(
            "visibility-hidden",
            inventorySource.innerText === ""
          );

        const addButtonUpdated = html.getElementById(
          `ProductSubmitButton-${sectionId}`
        );
        this.toggleAddButton(
          addButtonUpdated ? addButtonUpdated.hasAttribute("disabled") : true,
          window.variantStrings.soldOut
        );

        publish(PUB_SUB_EVENTS.variantChange, {
          data: {
            sectionId,
            html,
            variant: this.currentVariant,
          },
        });
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute("disabled", "disabled");
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute("disabled");
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    const inventory = document.getElementById(
      `Inventory-${this.dataset.section}`
    );
    const sku = document.getElementById(`Sku-${this.dataset.section}`);

    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add("visibility-hidden");
    if (inventory) inventory.classList.add("visibility-hidden");
    if (sku) sku.classList.add("visibility-hidden");
  }

  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define("variant-selects", VariantSelects);


class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  connectedCallback() {
    this.addEventListener('change', (event) => {
      const target = this.getInputForEventTarget(event.target);
      this.updateSelectionMetadata(event);

      publish(PUB_SUB_EVENTS.optionValueSelectionChange, {
        data: {
          event,
          target,
          selectedOptionValues: this.selectedOptionValues,
        },
      });
    });
  }

  updateSelectionMetadata({ target }) {
    const { value, tagName } = target;
   if (tagName === 'INPUT' && target.type === 'radio') {
      const selectedSwatchValue = target.closest(`.product-form__input`).querySelector('[data-selected-value]');
      if (selectedSwatchValue) selectedSwatchValue.innerHTML = value;
    }
  }

  getInputForEventTarget(target) {
    return target.tagName === 'SELECT' ? target.selectedOptions[0] : target;
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach(input => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.classList.remove('disabled');
      } else {
        input.classList.add('disabled');
      }
    });
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);


class ProductRecommendations extends HTMLElement {
  constructor() {
    super();

    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then(response => response.text())
        .then(text => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }
         if (html.querySelector('.grid__item')) {
                this.classList.add('product-recommendations--loaded');
                initButtons();
                initButtonsCompare();
            }
        })
        .catch(e => {
          console.error(e);
        });
    }

    new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 4000px 0px'}).observe(this);
  }
}

customElements.define('product-recommendations', ProductRecommendations);


// document.addEventListener('DOMContentLoaded', function () {
//   const matrixBtn = document.getElementById('matrix-add-to-cart');
//   if (!matrixBtn) return;

//   matrixBtn.addEventListener('click', function () {

//     // 1️⃣ Collect Upload-Lift (line item properties)
//     // const properties = {};
//     // document.querySelectorAll('[name^="properties["]').forEach(input => {
//     //   const name = input.name.replace('properties[', '').replace(']', '');
//     //   if (input.value) {
//     //     properties[name] = input.value;
//     //   }
//     // });

// const properties = {};

// // inputs/selects except radio
// document.querySelectorAll(
//   'input[name^="properties["]:not([type="radio"]), select[name^="properties["], textarea[name^="properties["]'
// ).forEach(el => {
//   const key = el.name.replace('properties[', '').replace(']', '');
//   if (el.value) properties[key] = el.value;
// });

// // checked radios only
// document.querySelectorAll('input[type="radio"][name^="properties["]:checked')
//   .forEach(radio => {
//     const key = radio.name.replace('properties[', '').replace(']', '');
//     properties[key] = radio.value;
//   });

//     // 2️⃣ Collect size matrix quantities
//     let items = [];
//     document.querySelectorAll('.size-qty-input').forEach(input => {
//       const qty = parseInt(input.value, 10);
//       if (qty > 0) {
//         items.push({
//           id: input.dataset.variantId,
//           quantity: qty,
//           properties: properties   // ✅ attach Upload-Lift data
//         });
//       }
//     });

//     if (!items.length) {
//       alert('Please select quantity for at least one size.');
//       return;
//     }

//     // 3️⃣ Add all variants to cart
//     fetch('/cart/add.js', {
//       method: 'POST',
//       headers: { 'Content-Type': 'application/json' },
//       body: JSON.stringify({ items })
//     })
//     .then(res => {
//       if (!res.ok) throw new Error('Add to cart failed');
//       return res.json();
//     })
//     .then(() => {
//       window.location.href = '/cart';
//     })
//     .catch(err => {
//       console.error(err);
//       alert('Unable to add items to cart.');
//     });
//   });
// });
function collectLineItemProperties() {
  const properties = {};
  document.querySelectorAll(
    'input[name^="properties["], select[name^="properties["], textarea[name^="properties["]'
  ).forEach(el => {
    // radios / checkboxes
    if (
      (el.type === 'radio' && !el.checked) ||
      (el.type === 'checkbox' && !el.checked)
    ) return;

    // skip empty
    const value = el.value?.trim();

    if (value === '') return;

    // OPTIONAL: skip zero quantities
    if (el.type === 'number' && Number(el.value) === 0) return;

    const name = el.name
      .replace('properties[', '')
      .replace(']', '');

    properties[name] = value;
  });
  console.log("properties",properties);
  return properties;
}
document.addEventListener('click', function (e) {
  if (!e.target.matches('#matrix-add-to-cart')) return;

  e.preventDefault();

  const form = document.querySelector('form[action^="/cart/add"]');
  if (!form) return;

  const properties = collectLineItemProperties();

  const items = [];

  // 1️⃣ Get current selected variant (this reflects color swatch)
  const variantInput = document.querySelector('input[name="id"]');
  if (!variantInput) return;

  const currentVariantId = Number(variantInput.value);
  const baseVariant = window.PRODUCT_VARIANTS.find(v => v.id === currentVariantId);
  if (!baseVariant) return;

  // 2️⃣ Identify size option index
  const sizeMatrix = document.querySelector('.size-matrix');

  console.log("sizeMatrix",sizeMatrix);
  // 🟢 NON-APPAREL (Business cards, etc.)
  if (!sizeMatrix) {
    // ✅ Let Shopify + apps do their job
    form.submit();
    return;
  }



  const sizeIndex = Number(sizeMatrix.dataset.sizeOptionIndex);
const sizes = {};
let _totalquantities=0;
// 3️⃣ Loop quantities
  // document.querySelectorAll('.size-input').forEach(input => {
  //   const qty = Number(input.value);
  //   if (!qty) return;
  //   if (qty > 0) {
  //     sizes[input.name.replace('properties[', '').replace(']', '')] = qty;
  //     _totalquantities += qty;
  //     console.log(`quantity: ${qty}`);
  //   }
  //   // 4️⃣ Resolve correct variant for CURRENT COLOR + THIS SIZE
  //   const match = window.PRODUCT_VARIANTS.find(v => {
  //     return v.options.every((opt, i) => {
  //       console.log(`sizeIndex=>,${sizeIndex}| i ${i} | opt:${opt} | sizeValue ${sizeValue}`);
  //       if (i === sizeIndex) return opt === sizeValue;
  //       return opt === baseVariant.options[i];
  //     });
  //   });
  //   if (!match) return;

  //   items.push({
  //     id: match.id,
  //     //quantity: qty,
  //     properties: { ...properties } // 🔑 Custom Properties
  //   });


  // });

  // 3️⃣ Loop quantities
  document.querySelectorAll('.size-qty-input').forEach(input => {
    const qty = Number(input.value);
    console.log(".size-qty-input' qty=>",qty);
    if (!qty) return;
    if (qty <= 0) return;

    const size = input.dataset.size;

    if (qty > 0) {
      sizes[input.name.replace('properties[', '').replace(']', '')] = qty;
      _totalquantities += qty;
      console.log(`Size: ${input.name.replace('properties[', '').replace(']', '')}, quantity: ${qty}`);
    }


    // const sizeValue = input.dataset.size;

    // //4️⃣ Resolve correct variant for CURRENT COLOR + THIS SIZE
    // const match = window.PRODUCT_VARIANTS.find(v => {
    //   return v.options.every((opt, i) => {
    //     console.log(`sizeIndex=>,${sizeIndex}| i ${i} | opt:${opt} | sizeValue ${sizeValue}`);
    //     if (i === sizeIndex) return opt === sizeValue;
    //     return opt === baseVariant.options[i];
    //   });
    // });
    // console.log("window.PRODUCT_VARIANTS match",match);

    // if (!match) return;

    // items.push({
    //   id: match.id,
    //   quantity: _totalquantities,
    //   properties: { ...properties } // 🔑 Custom Properties
    // });
  });


console.log(`_totalquantities:${_totalquantities}`);
  if (_totalquantities<1) {
    alert('Please select at least one size.');
    return;
  }

  items.push({
      id: baseVariant.id,
      quantity: _totalquantities,
      properties: { ...properties,...sizes } // 🔑 Custom Properties
    });

  // 5️⃣ Add to cart
  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ items })
  })
    .then(() => {
      window.location.href = '/cart';
    });
});

(function() {
  var DAYS = ['Sun','Mon','Tue','Wed','Thu','Fri','Sat'];
  var MONTHS = ['January','February','March','April','May','June',
                'July','August','September','October','November','December'];

  // Cache for fetched holidays
  var holidayCache = {};
  var holidaysFetched = false;
  var fetchPromise = null;

  // Function to fetch US holidays from a public API
  function fetchUSHolidays(year) {
    var apiUrl = 'https://date.nager.at/api/v3/PublicHolidays/' + year + '/US';
    
    return fetch(apiUrl)
      .then(function(response) {
        if (!response.ok) {
          throw new Error('Failed to fetch holidays');
        }
        return response.json();
      })
      .then(function(holidays) {
        var holidaySet = new Set();
        holidays.forEach(function(holiday) {
          var dateParts = holiday.date.split('-');
          var month = dateParts[1];
          var day = dateParts[2];
          holidaySet.add(month + '-' + day);
        });
        return holidaySet;
      })
      .catch(function(error) {
        console.warn('Failed to fetch holidays from API:', error);
        return new Set(); // Return empty set if API fails
      });
  }

  // Function to get holidays for a specific year with caching
  function getHolidaysForYear(year) {
    if (holidayCache[year]) {
      return Promise.resolve(holidayCache[year]);
    }
    
    if (fetchPromise) {
      return fetchPromise.then(function() {
        return holidayCache[year] || new Set();
      });
    }
    
    fetchPromise = fetchUSHolidays(year)
      .then(function(holidaySet) {
        holidayCache[year] = holidaySet;
        holidaysFetched = true;
        return holidayCache[year];
      })
      .finally(function() {
        fetchPromise = null;
      });
    
    return fetchPromise;
  }

  // Get observed holiday date (if holiday falls on weekend)
  function getObservedHoliday(date) {
    var month = date.getMonth();
    var day = date.getDate();
    var dayOfWeek = date.getDay();
    
    // Get the date string to check if it's a holiday
    var dateStr = String(month + 1).padStart(2, '0') + '-' + String(day).padStart(2, '0');
    var year = date.getFullYear();
    
    // Check if this date is actually a holiday
    if (holidayCache[year] && holidayCache[year].has(dateStr)) {
      // If holiday falls on Saturday, observe on Friday (day before)
      if (dayOfWeek === 6) { // Saturday
        var observed = new Date(date);
        observed.setDate(observed.getDate() - 1);
        return observed;
      }
      // If holiday falls on Sunday, observe on Monday (day after)
      else if (dayOfWeek === 0) { // Sunday
        var observed = new Date(date);
        observed.setDate(observed.getDate() + 1);
        return observed;
      }
    }
    
    return null; // No observed date needed
  }

  // Check if a date is a holiday (synchronous wrapper)
  function isHoliday(date) {
    var month = String(date.getMonth() + 1).padStart(2, '0');
    var day = String(date.getDate()).padStart(2, '0');
    var dateStr = month + '-' + day;
    var year = date.getFullYear();
    var dayOfWeek = date.getDay();
    
    // First check: Is it a weekend? (Saturday or Sunday)
    if (dayOfWeek === 6 || dayOfWeek === 0) {
      return true; // Saturday or Sunday are always non-working days
    }
    
    // Check if this date is an observed holiday (for holidays that fell on weekend)
    if (holidayCache[year]) {
      // Check if this date is the observed date for a weekend holiday
      var observedDate = getObservedHoliday(date);
      if (observedDate) {
        var observedMonth = String(observedDate.getMonth() + 1).padStart(2, '0');
        var observedDay = String(observedDate.getDate()).padStart(2, '0');
        if (month === observedMonth && day === observedDay) {
          return true;
        }
      }
      
      // Check if the actual date is a holiday
      if (holidayCache[year].has(dateStr)) {
        return true;
      }
    }
    
    // Check variable-date holidays (these are handled by the API, but keep as backup)
    // Thanksgiving (4th Thursday in November)
    if (date.getMonth() === 10) {
      var thanksgiving = getThanksgiving(date.getFullYear());
      if (date.getDate() === thanksgiving.getDate() && 
          date.getMonth() === thanksgiving.getMonth()) {
        return true;
      }
      // Day after Thanksgiving
      var dayAfter = new Date(thanksgiving);
      dayAfter.setDate(dayAfter.getDate() + 1);
      if (date.getDate() === dayAfter.getDate() && 
          date.getMonth() === dayAfter.getMonth()) {
        return true;
      }
    }
    
    // MLK Day (3rd Monday in January)
    if (date.getMonth() === 0) {
      var mlkDay = getNthDayOfMonth(3, 1, 0, date.getFullYear());
      if (date.getDate() === mlkDay.getDate() && 
          date.getMonth() === mlkDay.getMonth()) {
        return true;
      }
    }
    
    // Presidents Day (3rd Monday in February)
    if (date.getMonth() === 1) {
      var presidentsDay = getNthDayOfMonth(3, 1, 1, date.getFullYear());
      if (date.getDate() === presidentsDay.getDate() && 
          date.getMonth() === presidentsDay.getMonth()) {
        return true;
      }
    }
    
    // Memorial Day (last Monday in May)
    if (date.getMonth() === 4) {
      var memorialDay = getLastMondayOfMonth(4, date.getFullYear());
      if (date.getDate() === memorialDay.getDate() && 
          date.getMonth() === memorialDay.getMonth()) {
        return true;
      }
    }
    
    // Labor Day (1st Monday in September)
    if (date.getMonth() === 8) {
      var laborDay = getNthDayOfMonth(1, 1, 8, date.getFullYear());
      if (date.getDate() === laborDay.getDate() && 
          date.getMonth() === laborDay.getMonth()) {
        return true;
      }
    }
    
    // Columbus Day (2nd Monday in October)
    if (date.getMonth() === 9) {
      var columbusDay = getNthDayOfMonth(2, 1, 9, date.getFullYear());
      if (date.getDate() === columbusDay.getDate() && 
          date.getMonth() === columbusDay.getMonth()) {
        return true;
      }
    }
    
    return false;
  }

  // Helper function to get Thanksgiving date
  function getThanksgiving(year) {
    var date = new Date(year, 10, 1);
    var dayOfWeek = date.getDay();
    var daysToAdd = (4 - dayOfWeek + 7) % 7;
    date.setDate(1 + daysToAdd + 21);
    return date;
  }

  // Helper function to get nth day of month
  function getNthDayOfMonth(nth, dayOfWeek, month, year) {
    var date = new Date(year, month, 1);
    var firstDayOfWeek = date.getDay();
    var daysToAdd = (dayOfWeek - firstDayOfWeek + 7) % 7;
    date.setDate(1 + daysToAdd + (nth - 1) * 7);
    return date;
  }

  // Helper function to get last Monday of month
  function getLastMondayOfMonth(month, year) {
    var date = new Date(year, month + 1, 0);
    var dayOfWeek = date.getDay();
    var daysToSubtract = (dayOfWeek - 1 + 7) % 7;
    date.setDate(date.getDate() - daysToSubtract);
    return date;
  }

  function formatDate(date) {
    return (
      String(date.getDate()).padStart(2, '0') + '-' +
      String(date.getMonth() + 1).padStart(2, '0') + '-' +
      date.getFullYear()
    );
  }

  function formatFriendly(date) {
    return DAYS[date.getDay()] + ', ' + MONTHS[date.getMonth()] + ' ' + date.getDate();
  }

  // Add business days (skipping weekends and holidays)
  function addBusinessDays(date, days) {
    var result = new Date(date);
    var daysAdded = 0;
    
    // Move to next business day if starting on weekend or holiday
    while (result.getDay() === 6 || result.getDay() === 0 || isHoliday(result)) {
      result.setDate(result.getDate() + 1);
    }
    
    while (daysAdded < days) {
      result.setDate(result.getDate() + 1);
      // Skip Saturday, Sunday, or holiday
      if (result.getDay() !== 6 && result.getDay() !== 0 && !isHoliday(result)) {
        daysAdded++;
      }
    }
    return result;
  }

  // Get next business day
  function getNextBusinessDay(date) {
    var result = new Date(date);
    result.setDate(result.getDate() + 1);
    while (result.getDay() === 6 || result.getDay() === 0 || isHoliday(result)) {
      result.setDate(result.getDate() + 1);
    }
    return result;
  }

  function updateProductionDate() {
    var today = new Date();
    var startDate = new Date(today);
    
    // Skip weekends and holidays
    while (startDate.getDay() === 6 || startDate.getDay() === 0 || isHoliday(startDate)) {
      startDate.setDate(startDate.getDate() + 1);
    }
    
    var tomorrow = getNextBusinessDay(startDate);

    var target = document.getElementById('aco-prod-date');
    if (target) {
      target.textContent =
        formatDate(startDate) + ' - ' + formatDate(tomorrow);
    }
  }

  function updateDeliveryDate() {
    var descTarget = document.getElementById('aco-order-desc');
    var el = document.querySelector('.dynamic-date-input select, .dynamic-date-input input:checked');
    var days = parseInt(el ? el.value : 0) || 0;
    var date = new Date();
    
    date = addBusinessDays(date, days);
    
    // Ensure final date isn't weekend or holiday
    while (date.getDay() === 6 || date.getDay() === 0 || isHoliday(date)) {
      date.setDate(date.getDate() + 1);
    }

    var target = document.getElementById('aco-dynamic-date');
    if (target) target.textContent = formatFriendly(date);

    if (descTarget) {
      if (days > 1) {
        descTarget.textContent = "Depends on Art work Approval";
      } else {
        descTarget.textContent = "Next Business Day Cut-off time 05:00pm CT (Pickup or Uber Delivery)";
      }
    }
  }

  function updateCurrentDate() {
    var target = document.getElementById('aco-current-date');
    if (target) {
      target.textContent = formatDate(new Date());
    }
  }

  // Debug functions
  window.HolidayDebug = {
    getCache: function() { 
      return holidayCache; 
    },
    
    getStatus: function() { 
      return {
        fetched: holidaysFetched,
        years: Object.keys(holidayCache),
        totalHolidays: Object.values(holidayCache).reduce(function(sum, set) { 
          return sum + set.size; 
        }, 0)
      }; 
    },
    
    isHoliday: function(date) { 
      if (typeof date === 'string') {
        var parts = date.split('-');
        date = new Date(parseInt(parts[2]), parseInt(parts[1]) - 1, parseInt(parts[0]));
      }
      return isHoliday(date); 
    },
    
    getHolidaysForYear: function(year) {
      if (holidayCache[year]) {
        return Array.from(holidayCache[year]).sort();
      }
      return null;
    },
    
    // Test a specific date
    testDate: function(month, day, year) {
      var date = new Date(year, month - 1, day);
      var result = isHoliday(date);
      var dayName = DAYS[date.getDay()];
      var dateStr = month + '/' + day + '/' + year + ' (' + dayName + ')';
      var reason = '';
      
      if (result) {
        if (dayName === 'Sat' || dayName === 'Sun') {
          reason = ' (Weekend)';
        } else {
          // Check if it's an observed holiday
          var observed = getObservedHoliday(date);
          if (observed && observed.getDate() === date.getDate()) {
            reason = ' (Observed Holiday)';
          } else {
            reason = ' (National Holiday)';
          }
        }
      }
      
      console.log(dateStr + ' → ' + (result ? '✅ HOLIDAY' : '❌ WORKING DAY') + reason);
      return result;
    },
    
    // Test all holidays for a year
    testAll: function() {
      var year = new Date().getFullYear();
      console.log('=== TESTING HOLIDAYS FOR ' + year + ' ===');
      console.log('Weekend days (Sat/Sun) will show as HOLIDAY');
      console.log('----------------------------------------');
      
      // Test all major holidays
      var tests = [
        { month: 1, day: 1, name: 'New Year\'s Day' },
        { month: 1, day: 19, name: 'MLK Day' },
        { month: 2, day: 16, name: 'Presidents Day' },
        { month: 5, day: 25, name: 'Memorial Day' },
        { month: 7, day: 4, name: 'Independence Day' },
        { month: 9, day: 7, name: 'Labor Day' },
        { month: 10, day: 12, name: 'Columbus Day' },
        { month: 11, day: 11, name: 'Veterans Day' },
        { month: 12, day: 25, name: 'Christmas Day' },
        { month: 12, day: 26, name: 'Day after Christmas' }
      ];
      
      console.log('\n📅 NATIONAL HOLIDAYS:');
      tests.forEach(function(test) {
        var date = new Date(year, test.month - 1, test.day);
        var result = isHoliday(date);
        var dayName = DAYS[date.getDay()];
        var status = result ? '✅ YES' : '❌ NO';
        var extra = '';
        
        // Check if it's a weekend
        if (dayName === 'Sat' || dayName === 'Sun') {
          extra = ' (Weekend - automatically skipped)';
        }
        
        console.log('  ' + test.name.padEnd(20) + ' ' + test.month + '/' + test.day + 
                    ' (' + dayName + '): ' + status + extra);
      });
      
      // Check Thanksgiving
      var thanksgiving = getThanksgiving(year);
      var dayName = DAYS[thanksgiving.getDay()];
      console.log('  Thanksgiving'.padEnd(20) + ' ' + (thanksgiving.getMonth()+1) + '/' + 
                  thanksgiving.getDate() + ' (' + dayName + '): ' + 
                  (isHoliday(thanksgiving) ? '✅ YES' : '❌ NO'));
      
      // Show all holidays from API
      if (holidayCache[year] && holidayCache[year].size > 0) {
        console.log('\n📋 ALL HOLIDAYS FROM API (' + holidayCache[year].size + ' total):');
        var sortedHolidays = Array.from(holidayCache[year]).sort();
        sortedHolidays.forEach(function(h) {
          var parts = h.split('-');
          var date = new Date(year, parseInt(parts[0]) - 1, parseInt(parts[1]));
          var dayName = DAYS[date.getDay()];
          var isWeekend = (dayName === 'Sat' || dayName === 'Sun');
          console.log('  ' + h + ' (' + dayName + ')' + (isWeekend ? ' ⚠️ Weekend' : ' ✓ Weekday'));
        });
      }
      
      console.log('\n💡 Note: Weekend holidays are observed on the nearest business day');
      console.log('   Saturday → Friday before');
      console.log('   Sunday → Monday after');
    },
    
    // Test a week to see which days are working
    testWeek: function(year, month, day) {
      if (!year) year = new Date().getFullYear();
      if (!month) month = 1;
      if (!day) day = 1;
      
      var startDate = new Date(year, month - 1, day);
      console.log('=== WEEK TEST: Week starting ' + startDate.toLocaleDateString() + ' ===');
      console.log('S=Saturday, U=Sunday, H=Holiday, W=Working Day');
      console.log('----------------------------------------');
      
      for (var i = 0; i < 7; i++) {
        var date = new Date(startDate);
        date.setDate(date.getDate() + i);
        var dateStr = (date.getMonth()+1) + '/' + date.getDate() + '/' + date.getFullYear();
        var dayName = DAYS[date.getDay()];
        var isHolidayResult = isHoliday(date);
        var status = '';
        
        if (dayName === 'Sat') status = '🔴 SATURDAY (Weekend)';
        else if (dayName === 'Sun') status = '🔴 SUNDAY (Weekend)';
        else if (isHolidayResult) status = '🟡 HOLIDAY';
        else status = '🟢 WORKING DAY';
        
        console.log(dateStr + ' (' + dayName + '): ' + status);
      }
    },
    
    refresh: function() {
      var year = new Date().getFullYear();
      console.log('🔄 Refreshing holidays for ' + year + '...');
      delete holidayCache[year];
      return getHolidaysForYear(year).then(function() {
        console.log('✅ Refresh complete!');
        return HolidayDebug.getStatus();
      });
    }
  };

  function attachListener() {
    var container = document.querySelector('.dynamic-date-input');
    if (container) {
      var currentYear = new Date().getFullYear();
      Promise.all([
        getHolidaysForYear(currentYear),
        getHolidaysForYear(currentYear + 1)
      ]).then(function() {
        updateDeliveryDate();
        updateCurrentDate();
        updateProductionDate();
        console.log('✅ Holidays loaded! Use HolidayDebug.testAll() to verify.');
        console.log('📌 Both Saturday and Sunday are automatically skipped.');
      });
      
      container.addEventListener('change', updateDeliveryDate);
      container.addEventListener('click', updateDeliveryDate);
      return true;
    }
    return false;
  }

  document.addEventListener('DOMContentLoaded', function() {
    if (!attachListener()) {
      var observer = new MutationObserver(function() {
        if (attachListener()) {
          observer.disconnect();
        }
      });
      observer.observe(document.body, { childList: true, subtree: true });
    }
  });
})();